import React, { useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import ModalCreateEnterprise from "./ModalCreateEnterprise";
import { FaArrowRight } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";
import { BsBuildingAdd } from "react-icons/bs";
import useModal from "../../../../hooks/useModal";
import { DELETE_ENTERPRISE, GET_ENTERPRISE_BY_USER } from "../../../../api/apiEmpresas";
import Button from "../../../atoms/Button";
import SubHeading from "../../../atoms/SubHeading";
import Modal from "../../../molecules/Modal";
import NoData from "../../../atoms/NoData";
import { useNavigate } from "react-router-dom";
import ModalEditEnterprise from "./ModalEditEnterprise";
import ModalConfirm from "../../../molecules/ModalConfirm";
import { toast } from "react-toastify";
import { useSession } from "../../../../context/SessionContext";
import { getRegimen } from "../../../../data/regimenFiscalData";
import { getResponsibleName } from "../../../../functions/getNames";

const EmpresaTable = ({ clientId, accountants, admins }) => {
    const navigate = useNavigate ();
    const { open, close, isOpen } = useModal();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();
    const [empresas, setEmpresas] = useState();
    const [loading, setLoading] = useState(false);
    const [empresaEdit, setEmpresaEdit] = useState();
    const { user } = useSession();

    const handleOpenEdit = (empresa) => {
        setEmpresaEdit(empresa);
        open2();
    };

    const getEnterprises = useCallback(async () => {
		try {
            setLoading(true);
			const enterprisesData = await GET_ENTERPRISE_BY_USER(clientId);
            const sortedData = enterprisesData.sort((a, b) => a.id - b.id);
            setEmpresas(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	}, [clientId]);

	useEffect(() => {
        getEnterprises();
    }, [getEnterprises]);

    const handlePush = (id) => {
        navigate(`/clientes/empresas/${id}/decide`)
    };

    const handleOpenDelete = (empresa) => {
        setEmpresaEdit(empresa);
        open3();
    };

    const columns = [
        {name: "Nombre", cell: row =>(
            <div className="flex flex-col gap-1 my-1">
                <p className="text-blue-700 bg-blue-100 p-1 rounded-lg w-fit font-semibold">{row.name}</p>
                <p className="text-orange-700 bg-orange-100 p-1 rounded-lg w-fit font-semibold">{getRegimen(row.c_RegimenFiscal)}</p>
                <p className="text-gray-700 bg-gray-100 p-1 rounded-lg w-fit font-semibold">{row.rfc}</p>
            </div>
        )},
        {name: "Información", cell: row =>(
            <div className="flex flex-col gap-1 my-1">
                <p className="text-rose-700 bg-rose-100 p-1 rounded-lg w-fit font-semibold"> Contador: {getResponsibleName(row, accountants, admins)} </p>
                {row.isAccountingClient && <p className="text-purple-700 bg-purple-100 p-1 rounded-lg w-fit font-semibold">Cliente de contabilidad</p>}
                {row.isTaxDefenseClient && <p className="text-green-700 bg-green-100 p-1 rounded-lg w-fit font-semibold">Cliente de defensa fiscal</p>}
            </div>
        )},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                {user?.roleInfo?.isSuperAdmin === true &&
                    <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={() => handleOpenDelete(row)}/>
                }
                <Button text={<FaArrowRight size={22} />} width="w-10" bgColor="orange" onClick={()=> handlePush(row.id)} />
            </div>
        )}
    ];

    const columnsResponsive = [
        {name: "Lista de empresas", cell: row => (
            <div className="w-full flex flex-col justify-center items-center">
                <p> {row.name} </p>
                <p>{row.rfc}</p>
                <p>{getRegimen(row.c_RegimenFiscal)}</p>
                <div className="w-full flex flex-row justify-around">
                    <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                    <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={() => handleOpenDelete(row)}/>
                    <Button text={<FaArrowRight size={22} />} width="w-10" bgColor="orange" onClick={()=> handlePush(row.id)} />
                </div>
            </div>
        ), width:"100%",}
    ];

    const handleDeleteEnterprise = async () => {
        try {
            await DELETE_ENTERPRISE(empresaEdit?.id);
            toast.success("Empresa eliminda correctamente");
            close3();
            getEnterprises();
        } catch (error) {
            console.error(error);
            toast.error("Error al eliminar");
        }
    };

    return(
        <div className="rounded-b-lg p-2 border-t-0 md:border border-sky-200 mb-1">
            <div className="flex fle-row justify-between items-center">
                <SubHeading text="Empresas" color="black" />
                <Button text={<BsBuildingAdd size={22} />} width="w-10" bgColor="green" onClick={open}/>
            </div>
            <div className="block md:hidden">
                <DataTable
                    data={empresas}
                    columns={columnsResponsive}
                    progressPending={loading}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    dense
                    noDataComponent={<NoData />}
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={empresas}
                    columns={columns}
                    progressPending={loading}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    dense
                    noDataComponent={<NoData />}
                />
            </div>
            {isOpen &&
                <Modal title="Crear empresa" onClose={close}>
                    <ModalCreateEnterprise onClose={close} refetch={getEnterprises} userId={clientId}/>
                </Modal>
            }
            {isOpen2 &&
                <Modal title="Editar empresa" onClose={close2}>
                    <ModalEditEnterprise onClose={close2} refetch={getEnterprises} empresa={empresaEdit} />
                </Modal>
            }
            {isOpen3 &&
                <ModalConfirm onClose={close3} onConfirm={handleDeleteEnterprise} eliminacion />
            }
        </div>
    );
};

export default EmpresaTable;